import {
  BessSubmercado,
  FormValues,
  PerfilConsumo,
  SIMULATION_SIDE_TYPES,
  SimulationSideType,
} from "../types";
import { parseNum } from "../transformValues";

export interface BessSimulatePayload {
  // Sem medição a série é sintética e vem de mesReferencia + perfilConsumo.
  medicaoCsv?: string;
  pontoMedicao?: string;
  mesReferencia?: string; // 'YYYY-MM'
  perfilConsumo?: PerfilConsumo;
  submercado: BessSubmercado;
  distribuidora: string;
  ths: string;
  grupoTarifario: string;
  precoEnergia: number; // R$/MWh — precoEnergia[0] do form, parseado
  potenciaBateria: number;
  energiaMaximaArmazenada: number;
  rteBateria: number; // decimal (90 → 0.9, 2 casas)
  dod: number; // decimal (90 → 0.9, 2 casas)
  demandaContratada: number; // = demandaForaPonta do form
  tipoSimulacao: SimulationSideType; // segundo cenário; só APE habilita injeção
  desconto: number; // values.desconto já é número decimal
  pis: number;
  cofins: number;
  icms: number; // decimais (1,65% → 0.0165)
  dataSimulacao: string; // new Date().toISOString()
}

export function buildBessPayload(values: FormValues): BessSimulatePayload {
  const body: BessSimulatePayload = {
    submercado: values.submercado as BessSubmercado,
    distribuidora: values.distribuidora,
    ths: values.ths,
    grupoTarifario: values.grupoTarifario,
    precoEnergia: parseNum(values.precoEnergia[0]),
    potenciaBateria: parseNum(values.potenciaBateria),
    energiaMaximaArmazenada: parseNum(values.energiaMaximaArmazenada),
    rteBateria: +(parseNum(values.rteBateria) / 100).toFixed(2),
    dod: +(parseNum(values.dod) / 100).toFixed(2),
    demandaContratada: parseNum(values.demandaForaPonta),
    tipoSimulacao: SIMULATION_SIDE_TYPES[values.simulationType].second,
    desconto: values.desconto,
    pis: parseNum(values.pis) / 100,
    cofins: parseNum(values.cofins) / 100,
    icms: parseNum(values.icms) / 100,
    dataSimulacao: new Date().toISOString(),
  };

  if (values.medicaoCsv) {
    body.medicaoCsv = values.medicaoCsv;
    if (values.pontoMedicaoBess) {
      body.pontoMedicao = values.pontoMedicaoBess;
    }
  } else {
    body.mesReferencia = values.mesReferencia;
    body.perfilConsumo = values.perfilConsumo as PerfilConsumo;
  }

  return body;
}
